'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var index = require('./../../../external/classnames/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var ContactsBlock = function ContactsBlock(_ref) {
  var dividerBottom = _ref.dividerBottom,
    dividerTop = _ref.dividerTop,
    className = _ref.className,
    displayEmail = _ref.displayEmail,
    displayLabAddress = _ref.displayLabAddress,
    contacts = _ref.contacts;
  var classes = index.default('contacts-block', dividerBottom && 'divider-bottom', dividerTop && 'divider-top', className);
  var header = contacts.length > 1 ? 'CONTACTS' : 'CONTACT';
  return /*#__PURE__*/React__default.default.createElement("div", {
    className: classes,
    "data-testid": "lanl-contacts-block"
  }, /*#__PURE__*/React__default.default.createElement("h3", {
    className: "sidebar-header"
  }, header), contacts && contacts.map(function (_ref2, index) {
    var header = _ref2.header,
      _ref2$hide_header = _ref2.hide_header,
      hide_header = _ref2$hide_header === void 0 ? false : _ref2$hide_header,
      name = _ref2.name,
      mailStop = _ref2.mailStop,
      email = _ref2.email,
      phone = _ref2.phone;
    return /*#__PURE__*/React__default.default.createElement("div", {
      className: "contact",
      key: "contact-".concat(index)
    }, !hide_header && header && /*#__PURE__*/React__default.default.createElement("p", {
      className: "contact-address bold"
    }, header), name && /*#__PURE__*/React__default.default.createElement("p", {
      className: "contact-address ".concat(hide_header && 'no-header')
    }, name), (displayLabAddress || mailStop) && /*#__PURE__*/React__default.default.createElement("p", {
      className: "contact-address"
    }, "Los Alamos National Laboratory"), mailStop && /*#__PURE__*/React__default.default.createElement("p", {
      className: "contact-address"
    }, mailStop), (displayLabAddress || mailStop) && /*#__PURE__*/React__default.default.createElement("p", {
      className: "contact-address"
    }, "Los Alamos, NM 87545"), email && /*#__PURE__*/React__default.default.createElement("a", {
      className: "contact-link",
      href: "mailto:".concat(email)
    }, displayEmail ? email : 'Email'), phone && /*#__PURE__*/React__default.default.createElement("p", {
      className: "contact-address"
    }, phone));
  }));
};
ContactsBlock.defaultProps = {
  dividerBottom: false,
  dividerTop: false,
  displayEmail: false,
  displayLabAddress: true
};
ContactsBlock.propTypes = {
  className: PropTypes__default.default.string,
  contacts: PropTypes__default.default.arrayOf(PropTypes__default.default.shape({
    email: PropTypes__default.default.string,
    header: PropTypes__default.default.string,
    hide_header: PropTypes__default.default.bool,
    mailStop: PropTypes__default.default.string,
    name: PropTypes__default.default.string,
    phone: PropTypes__default.default.string
  }).isRequired),
  displayEmail: PropTypes__default.default.bool,
  displayLabAddress: PropTypes__default.default.bool,
  dividerBottom: PropTypes__default.default.bool,
  dividerTop: PropTypes__default.default.bool
};

exports.ContactsBlock = ContactsBlock;
exports.default = ContactsBlock;
//# sourceMappingURL=ContactsBlock.js.map
